const FromArr = [{
		title: "产品型号/名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 182,
		height: 32,
		disabled: false,
		marginLeft: 25,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		title: "生产厂商：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		title: "申请单号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 182,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "客户：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 182,
		height: 32,
		disabled: false,
		marginLeft: 75,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "用途：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 182,
		height: 32,
		disabled: false,
		marginLeft: 85,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "创建时间：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "发布时间",
		widthLeft: 238,
		widthRight: 238,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 85,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "医院：",
		inputtype: "selectSingle",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 220,
		height: 32,
		disabled: false,
		marginLeft: 88,
		marginTop: 18,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'AuthorizedDealer'
	}, {
		title: "样品类型：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 36,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		title: "是否上传附件：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 17,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [{
			key: '1',
			value: '已上传'
		}, {
			key: '0',
			value: '未上传'
		}]
	}
]
export default FromArr;